export default {
    namespaced: true,
    state: {
        opened: false,
    },
    mutations: {
        toogle: function(state) {
            state.opened = !state.opened;

            if(state.opened) {
                $("body").css("overflow","hidden");
            }
            else {
                $("body").css("overflow","visible");
            }
        },

        close: function(state) {
            state.opened = false;

            $("body").css("overflow","visible");
        }
    },
    actions: {
        toogleSideMenu({commit}) {
            commit('toogle');
        },

        closeSideMenu({commit}) {
            commit('close');
        },
    },
    getters: {
        sideMenuOpened: function(state) {
            return state.opened;
        },
    }
}
